import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WeightsTableComponent } from '../weights-table/weights-table.component';
import { MediaObserver } from '@angular/flex-layout';

@Component({
  selector: 'app-alert-invalid-country',
  templateUrl: './alert-invalid-country.component.html',
  styleUrls: ['./alert-invalid-country.component.css']
})

export class AlertInvalidCountryComponent implements OnInit {

  delivryAddress: any;
  innerHeight:number = window.innerHeight;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialogRef: MatDialogRef<AlertInvalidCountryComponent>,
    private dialog: MatDialog,
    private media: MediaObserver
  ) {
    this.delivryAddress = data.delivryAddress;
  }

  ngOnInit() { }

  openWeightTableDial() {
    let myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = { delivryAddress: this.delivryAddress }
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "350px";
    this.dialog.open(WeightsTableComponent, myConf);
  }

  closeDial() {
    this.dialogRef.close();
  }

}
